module.exports = __webpack_public_path__ + "img/Ardunic Elements-191.2df0f72d.svg";